export enum KeyLocalStorage {
    NPAPER_AUTH_TOKEN = 'npaper-auth-token',
    NPAPER_USER_DATA = 'npaper-user-data',
    NPAPER_CUSTOMER_DEFAULT = 'npaper-customer-default',
}
